// extracted by mini-css-extract-plugin
module.exports = {"coin":"styles_coin__6XY5f","coin__content":"styles_coin__content__1UZzN","green":"styles_green__wa81m","red":"styles_red___0jVt","gray":"styles_gray__ClmsV"};